<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';
import { NODE_TYPES } from '../../constants';
import FlowNodeCard from './FlowNodeCard.vue';

const props = defineProps({
  data: { type: Object, required: true },
  selected: { type: Boolean, default: false },
});
const meta = NODE_TYPES.message;
const preview = computed(() => props.data.text || '(sem texto ainda)');
</script>

<template>
  <FlowNodeCard :icon="meta.icon" :color="meta.color" :title="meta.label" :selected="selected">
    <Handle type="target" :position="Position.Left" />
    <p class="line-clamp-3 whitespace-pre-wrap">{{ preview }}</p>
    <Handle type="source" :position="Position.Right" />
  </FlowNodeCard>
</template>
